import _isEmpty from 'lodash/isEmpty';
var MenuUtil = {
  getScheduleCategories: function getScheduleCategories() {
    var scheduleCategories = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    var categories = arguments.length > 1 ? arguments[1] : undefined;
    var preserveEntitiesOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return MenuUtil.getLinkedEntities(scheduleCategories, categories, preserveEntitiesOrder);
  },
  getCategoryItems: function getCategoryItems(categoryItemIds, items) {
    var categoryItems = MenuUtil.getLinkedEntities(categoryItemIds, items, true);
    // return only the items that are visible
    return categoryItems.filter(function (_ref) {
      var _ref$visible = _ref.visible,
        visible = _ref$visible === void 0 ? true : _ref$visible;
      return visible;
    });
  },
  getItemModifierSets: function getItemModifierSets(itemModifierSetIds, modifierSets) {
    var preserveEntitiesOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return MenuUtil.getLinkedEntities(itemModifierSetIds, modifierSets, preserveEntitiesOrder);
  },
  getItemModifiers: function getItemModifiers(itemModifiersIds, modifiers) {
    return MenuUtil.getLinkedEntities(itemModifiersIds, modifiers, true);
  },
  getModifierSetModifiers: function getModifierSetModifiers(modifierSetModifiers, modifiers) {
    var preserveEntitiesOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
    return MenuUtil.getLinkedEntities(modifierSetModifiers, modifiers, preserveEntitiesOrder);
  },
  getScheduleById: function getScheduleById(schedules, scheduleId) {
    return schedules.filter(function (_ref2) {
      var _id = _ref2._id;
      return scheduleId === _id;
    })[0];
  },
  getCategoryById: function getCategoryById(categories, category) {
    return categories.filter(function (_ref3) {
      var _id = _ref3._id;
      return category === _id;
    })[0];
  },
  getItemById: function getItemById(items, itemId) {
    return items.filter(function (_ref4) {
      var _id = _ref4._id;
      return itemId === _id;
    })[0];
  },
  getModifierSetById: function getModifierSetById(modifierSets, modifierSetId) {
    return modifierSets.filter(function (_ref5) {
      var _id = _ref5._id;
      return modifierSetId === _id;
    })[0];
  },
  getMenuItemVariations: function getMenuItemVariations(item) {
    var variations = item.variations;
    return variations;
  },
  menuItemHasOneVariation: function menuItemHasOneVariation(item) {
    var variations = MenuUtil.getMenuItemVariations(item);
    return variations.length === 1;
  },
  getLinkedEntities: function getLinkedEntities(entityIds, entitiesToLink) {
    var preserveEntitiesOrder = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    if (!entitiesToLink || !entitiesToLink.length) {
      return [];
    }
    if (preserveEntitiesOrder) {
      return entityIds.map(function (entityId) {
        return entitiesToLink.find(function (_ref6) {
          var _id = _ref6._id;
          return _id === entityId;
        });
      });
    }
    return entitiesToLink.filter(function (_ref7) {
      var _id = _ref7._id;
      return entityIds.includes(_id);
    });
  },
  hasImageInSomeItems: function hasImageInSomeItems(items) {
    return items.some(function (_ref8) {
      var image = _ref8.image,
        gatsbyImage = _ref8.gatsbyImage;
      return image || !_isEmpty(gatsbyImage);
    });
  }
};
export default MenuUtil;